import React, { Component } from 'react';
import { connect } from 'react-redux'
import { translate } from 'react-translate';
//IMPORT SEMANTIC COMPONENTS
import 'semantic-ui-css/semantic.min.css';
import {
    Modal,
    Grid,
    Image,
    Header,
    Icon,
    Button
} from 'semantic-ui-react';


import createList from '../../../assets/icons/createList.png';
import AddList from './AddList'
import { modalCreateList } from '../../../redux/actions/ListAction';

import Exit from '../../../assets/svg/Exit.svg';



const mapStateToProps = state => ({
    app: state.app,
    list: state.list
})

const mapActionToProps = {
    modalCreateList: modalCreateList
}

class ConnectedCreateList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            modalOpen: false
        }

        this.closeModalCreateList = this.closeModalCreateList.bind(this)
        this.openModalCreateList = this.openModalCreateList.bind(this)
    }

    openModalCreateList() {
        this.props.modalCreateList(true);
    }

    closeModalCreateList() {
        this.props.modalCreateList(false);
    }

    render() {
        const { t } = this.props
        return (
            <div>
                <Modal size='tiny' open={this.props.list.modal_createList}
                    onClose={this.closeModalCreateList} trigger={
                        <Grid.Column>
                            <Button
                                circular
                                onClick={this.openModalCreateList}
                                size='small'
                                id="smallBtn">
                                <Icon name='plus circle'/> {t('title1')}
                            </Button>
                        </Grid.Column>
                    }>
                    <Modal.Header id="modalHeader">

                        <Grid>
                            <Grid.Row> 
                                <Grid.Column textAlign='center'>
                                    <Image
                                      onClick={this.closeModalCreateList}
                                      src={Exit}
                                      floated='right'
                                      id="modalExit" />
                                    <Header
                                      id="modalTitle"
                                      as='h2'
                                      textAlign='center'>
                                      {t("title1")}
                                    </Header>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Modal.Header>
                    <Modal.Content >
                        <AddList />
                    </Modal.Content>
                </Modal>
            </div>
        )
    }
}
const CreateList = connect(mapStateToProps, mapActionToProps)(ConnectedCreateList);
export default translate("CreateList")(CreateList);



// WEBPACK FOOTER //
// ./src/components/Protected/Listes/CreateList.js